import { catalogs } from "./locales/index.js";
import { localeTag, normalizeLocale, t } from "./translate.js";

/**
 * @param {string | undefined} locale
 */
export function getOgLocale(locale) {
  return normalizeLocale(locale) === "nl" ? "nl_NL" : "en_US";
}

/**
 * @param {string | undefined} locale
 */
export function getSeoDefaults(locale) {
  const resolved = normalizeLocale(locale);
  const catalog = catalogs[resolved]?.web?.seo;
  const fallback = catalogs.en?.web?.seo;

  return {
    defaultTitle: catalog?.defaultTitle ?? fallback?.defaultTitle ?? "Plaatplan",
    defaultDescription: catalog?.defaultDescription ?? fallback?.defaultDescription ?? "",
    ogImageAlt: catalog?.ogImageAlt ?? fallback?.ogImageAlt ?? "Plaatplan",
    inLanguage: localeTag(resolved),
    ogLocale: getOgLocale(resolved),
    features: catalog?.features ?? fallback?.features ?? [],
  };
}

/**
 * @param {string} key
 * @param {string | undefined} locale
 */
export function tSeo(key, locale) {
  return t(`web.seo.${key}`, locale);
}
